import i18next from 'i18next';

i18next.addResources('es_CL', 'AnnulOrder', {
  confirmOp: '¿Estás seguro de anular la orden # {{id}}?',
  deliveryMount: 'El valor del delivery',
  peyaWarning: 'NO podrá ser devuelto.',
  mountRefunded: 'será devuelto.',
  confirmation: 'Sí, ',
  annulOrder: 'anular orden',
  reason: 'Motivo de anulación',
  writeHere: 'Escribe aquí ...',
  cancel: 'Cancelar',
  required: 'Requerido',
  cancelDeliveryError: 'El delivery no pudo ser cancelado.',
  confirmWithoutDeliveryCancel: '¿Continuar con la anulación de la orden?',
  annulOrderStatus: 'La orden fue anulada correctamente',
  annulOrderAndDeliveryStatus: 'La orden y el delivery fueron anulados correctamente.'
});

i18next.addResources('es_CR', 'AnnulOrder', {
  confirmOp: '¿Estás seguro de anular la orden # {{id}}?',
  deliveryMount: 'El valor del delivery',
  peyaWarning: 'NO podrá ser devuelto.',
  mountRefunded: 'será devuelto.',
  confirmation: 'Sí, ',
  annulOrder: 'anular orden',
  reason: 'Motivo de anulación',
  writeHere: 'Escribe aquí ...',
  cancel: 'Cancelar',
  required: 'Requerido',
  cancelDeliveryError: 'El delivery no pudo ser cancelado.',
  confirmWithoutDeliveryCancel: '¿Continuar con la anulación de la orden?',
  annulOrderStatus: 'La orden fue anulada correctamente',
  annulOrderAndDeliveryStatus: 'La orden y el delivery fueron anulados correctamente.'
});
